import React from "react";
import { connect } from "react-redux";

import { generateStateKey } from "../../../../../utilities/generateStateKey";
import { cl } from "../../../../../utilities/cl";

import { OBJECT_MUSIC, OBJECT_OBJECT } from "../../../../../store/Settings/sets";
import Settings from "../../../../../components/Settings";

import Collapsible from "../../../../../components/Space/Collapsible";
import ScrollContainer from "../../../../../components/ScrollContainer";
import { download } from "../../../../../utilities/download";
import DiskSize from "../../../../../components/DiskSize";
import { baseURL } from "../../../../../sagas/root";
import { buildQueryString } from "../../../../../utilities/buildQueryString";
import { showAlertInfo } from "../../../../../store/Alert/actions";

const SettingsObjectCollapsible = ({
  className = "",
  selectedObjects,
  selectedObjectsGroup,
  placeNumber,
  active,
  showAlertInfo,
}) => {
  const stateKey = generateStateKey([selectedObjects]);

  const hSave = () => {
    try {
      const collapsible = document.querySelector(
        ".SettingsObjectMusicCollapsible",
      );
      const buttonSave = collapsible.querySelector(
        ".SettingsObjectMusicSave button",
      );
      console.log({buttonSave});
      
      if (buttonSave) {
        buttonSave.click();
      }
    } catch (e) {
      console.log("hSave", { e });
    }
  };


  className = cl(className, "SettingsObjectMusicCollapsible");
  

  className = cl(className, {
    "d-none": selectedObjectsGroup.length,
  });
  return (
    <Collapsible
      active={active}
      id={211}
      className={className}
      title="Настройки музыки"
      placeNumber={placeNumber}
      scroll={{
        on: true,
        data: {
          size: "lg",
        },
      }}
      buttons={{
        save: {
          on: true,
          mobile: false,
          onClick: hSave,
        },
      }}
    >
      <Settings
        set={OBJECT_MUSIC}
        data={{
          objectIds: selectedObjects,
          stateKey: stateKey,
        }}
      />
    </Collapsible>
  );
};

const actionsToProps = {
  showAlertInfo,
};

const stateToProps = (state) => ({
  selectedObjects: [...state.objects.selected],
  selectedObjectsGroup: [...state.objectsGroup.selected],
});

export default connect(stateToProps, actionsToProps)(SettingsObjectCollapsible);
